import styled from 'styled-components';
import { rem } from 'polished';
import { VehicleDetailsHeadingInformationStyled } from '../VehicleDetailsHeadingInformationStyled';
export const VehicleDetailsHeadingInformationStyledAC = styled(VehicleDetailsHeadingInformationStyled)`
    margin-top: ${rem(30)};

    .information {
        .titleWithBenefits {
            .show-characteristics-button {
                .link {
                    color: ${({ theme }) => theme.colors.red};
                }

                .linkIcon {
                    svg > path {
                        fill: ${({ theme }) => theme.colors.red} !important;
                        stroke: ${({ theme }) => theme.colors.red} !important;
                    }
                }

                &:hover {
                    .link {
                        color: ${({ theme }) => theme.colors.grey5};
                    }

                    .linkIcon svg > path {
                        fill: ${({ theme }) => theme.colors.grey5} !important;
                        stroke: ${({ theme }) => theme.colors.grey5} !important;
                    }
                }
            }
        }
    }
`;
